const SwedenCountryCode = 'SE';

export const isInternationalShippingToCountryAllowed = (
    region: string,
    countryCodeIso2: string,
) => {
    switch (region) {
        case 'Sweden':
            return isSwedenCountryCode(countryCodeIso2);
        case 'Nordic':
            return isNordicCountryCode(countryCodeIso2);
        case 'EU':
            return isEuCountryCode(countryCodeIso2);
        case 'International':
            return true;
        default:
            throw `Unhandled buyer region: ${region}`;
    }
};

export const isSwedenCountryCode = (countryCodeIso2: string) =>
    isCountryCode(SwedenCountryCode, countryCodeIso2);

export const isNordicCountryCode = (countryCodeIso2: string) =>
    containsCode(nordicCountryCodes, countryCodeIso2);

export const isEuCountryCode = (countryCodeIso2: string) =>
    containsCode(euCountryCodes, countryCodeIso2);

const containsCode = (codes: readonly string[], code: string) =>
    !!codes.find((c) => isCountryCode(code, c));

const isCountryCode = (c1: string, c2: string) =>
    c1.toUpperCase() === c2.toUpperCase();

const nordicCountryCodes = [
    'SE',
    'FI',
    'NO',
    'DK',
    'IS',
    'GL',
    'FO',
    'AX',
    'SJ',
] as const;

const euCountryCodes = [
    'AT',
    'BE',
    'BG',
    'CZ',
    'DE',
    'DK',
    'EE',
    'EL',
    'ES',
    'FI',
    'FR',
    'GR',
    'HR',
    'HU',
    'IE',
    'IT',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
] as const;
